import type { FiltersConfigState } from '@/reducers/filtersConfig';
import type { SearchState } from '@/reducers/search';
import type { SnackBarState } from '..';
import { create as createNoAllCategoriesAndLocationsStrategy } from './categoriesAndLocationStrategy';
import { create as createClosedByButton } from './closedByButton';
import { create as createSearchButtonExitFromViewport } from './searchButtonOutOfViewport';
import { create as createSearchNotSavedStrategy } from './searchNotSavedDisplayStrategy';

export type DisplayStrategyFactory = (
  state: SnackBarState,
  setState: (s: Pick<SnackBarState, keyof SnackBarState>) => void
) => DisplayStrategy;

export type DisplayStrategyCallback = (
  search: SearchState,
  filtersConfig: FiltersConfigState
) => Promise<boolean>;

export interface DisplayStrategy {
  [index: string]: DisplayStrategyCallback;
}

export const createDisplayStrategies: DisplayStrategyFactory = (
  state: SnackBarState,
  setState: (s: Pick<SnackBarState, keyof SnackBarState>) => void
) => ({
  searchNotSaved: createSearchNotSavedStrategy(state),
  noAllCategoriesAndLocations: createNoAllCategoriesAndLocationsStrategy(),
  searchButtonExitFromViewport: createSearchButtonExitFromViewport(
    state,
    setState
  ),
  closedByButton: createClosedByButton(state),
});
